import React, { createContext, useContext, useState, useEffect } from "react";
import { getLocalStorage } from "../Utils/Utils";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = getLocalStorage("token");
    const name = getLocalStorage("name");
    const credit = getLocalStorage("credit");
    const accountId = getLocalStorage("accountid");
    if (token && name) {
      setUser({ name, credit, accountId });
    }
  }, []);

  const login = (userData) => {
    setUser(userData);
  };

  const logout = () => {
    setUser(null);
    localStorage.clear();
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
